const eventTradeInterest = () => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `branch_minta_penawaran_button`,
      eventCategory: `localized landing page`,
      eventAction: `click on minta penawaran`,
      eventLabel: `branch page - plp`,
    });
  }
};
export default eventTradeInterest;
